<template>
  <div class="loans-root">
    <div>
      <Form @submit="onSubmit">
        <Card title="用户信息">
          <Field
            v-model="username"
            name="name"
            label="姓名"
            left-icon="contact"
            placeholder="请输入姓名"
            :rules="[{ required: true, message: '请填写姓名' }]"
          />
          <Field
            v-model="phoneNUmber"
            name="mobile"
            label="手机号"
            type="tel"
            left-icon="phone-circle-o"
            placeholder="请输入联系方式"
            :rules="[{ required: true, message: '请填写联系方式' }]"
          />
        </Card>
        <Card title="保险信息">
          <Field
            v-model="money_jqx"
            name="money_jqx"
            label="交强险金额"
            type="number"
            left-icon="award-o"
            placeholder="请输入交强险金额"
            :rules="[{ required: true, message: '请填写交强险金额' }]"
          />
          <Field
            v-model="money_ccs"
            name="money_ccs"
            label="车船税金额"
            type="number"
            left-icon="logistics"
            placeholder="请输入车船税金额"
            :rules="[{ required: true, message: '请填写车船税金额' }]"
          />
          <Field
            v-model="money_syx"
            name="money_syx"
            label="商业险金额"
            type="number"
            left-icon="flag-o"
            placeholder="请输入商业险金额"
            :rules="[{ required: true, message: '请填写商业险金额' }]"
          />
          <Collapse v-model="stages" accordion>
            <CollapseItem title="分期次数" name="1">
              <Field name="stages">
                <template #input>
                  <div style="width:100%">
                    <RadioGroup v-model="radio">
                      <CellGroup :border="false">
                        <Cell title="3" clickable @click=" radio = '3'">
                          <Radio slot="right-icon" name="3" />
                        </Cell>
                        <Cell title="6" clickable @click=" radio = '6'">
                          <Radio slot="right-icon" name="6" />
                        </Cell>
                        <Cell title="9" clickable @click=" radio = '9'">
                          <Radio slot="right-icon" name="9" />
                        </Cell>
                      </CellGroup>
                    </RadioGroup>
                  </div>
                </template>
              </Field>
            </CollapseItem>
          </Collapse>
        </Card>
        <Card title="备注">
          <Field
            v-model="message"
            rows="2"
            autosize
            name="notes"
            type="textarea"
            maxlength="50"
            placeholder="请填写备注信息"
            show-word-limit
          />
        </Card>
        <div style="margin: 16px;">
          <Button round block type="info" native-type="submit">
            提交
          </Button>
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
import { api,http } from 'utils/'
import Card from '@/components/Card'
export default {
  data() {
    return{
      showPicker:false,
      username:"",
      phoneNUmber:"",
      money_ccs:"",
      money_jqx:"",
      money_syx:"",
      stages:"",
      radio:"",
      price:"",
      message:""
    }
  },
  components:{
    Card
  },
  created() {
    document.title = '保险分期'
  },
  methods:{
    async postHandle(data) {
      const res = await http({
        url:api.insurceApi,
        method:'POST',
        data:{
          ...data,
          service_type:2
        }
      })
      if(res) {
        this.$router.push('/success')
      }
      console.log(res)
    },
    onSubmit(values) {
      this.postHandle(values)
      console.log('submit', values);
    }
  }
}
</script>

<style lang="less">
.loans-root{
  padding: 20px 12px;
  width: 100%;
  height: 100%;
  overflow: auto;
  .van-cell__title {
    text-align: left;
  }
}
</style>